import { CatalogItemType } from '@common/model/catalog/item/type';
import { CareerId } from '@common/const/catalog/career';
import { coreCatalogApi } from '@cp/entities/catalog';

export const useGetLocations = (catalogType?: CatalogItemType, careerId?: CareerId, cityId?: number) => {
  const { data: locations } = coreCatalogApi.endpoints.getMapCatalogItems.useQuery(
    {
      type: catalogType || CatalogItemType.Resume,
      careerId: careerId || 1,
      cityId,
      pagination: 1000,
    },
    {
      skip: !cityId,
    },
  );

  return locations
    ? locations.filter((item) => {
        return item.location || item.clientProfile?.location;
      })
    : [];
};
